module.exports = __webpack_public_path__ + "assets/images/gold-d4ff2a33dc334ae2f7169e55fb739a78.png";